import React from "react";
import {
  FaEnvelope,
  FaFacebook,
  FaGlobe,
  FaInstagram,
  FaMapMarkerAlt,
  FaPalette,
  FaPhoneAlt,
} from "react-icons/fa";

const inputClass =
  "w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-orange-400 focus:bg-white focus:ring-4 focus:ring-orange-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-orange-500/10";

function Field({
  label,
  name,
  value,
  onChange,
  placeholder,
  icon: Icon,
  type = "text",
}) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200">
        {label}
      </label>

      <div className="relative">
        {Icon && (
          <Icon className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
        )}

        <input
          type={type}
          name={name}
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          className={`${inputClass} ${Icon ? "pl-11" : ""}`}
        />
      </div>
    </div>
  );
}

export default function ContactSocialPanel({ settings, onChange }) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none">
      <div>
        <p className="text-sm font-bold uppercase tracking-[0.18em] text-orange-600 dark:text-orange-300">
          Coordonnées
        </p>

        <h2 className="mt-2 text-2xl font-bold text-slate-950 dark:text-white">
          Contact, adresse et réseaux sociaux
        </h2>

        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
          Ces informations sont généralement affichées dans le footer, la page
          contact ou les blocs d’informations du site.
        </p>
      </div>

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        <Field
          label="Adresse du club"
          name="adresse_club"
          value={settings.adresse_club}
          onChange={onChange}
          placeholder="Adresse complète"
          icon={FaMapMarkerAlt}
        />

        <Field
          label="Commune"
          name="commune_club"
          value={settings.commune_club}
          onChange={onChange}
          placeholder="Commune"
          icon={FaMapMarkerAlt}
        />

        <Field
          label="Téléphone"
          name="tel_club"
          value={settings.tel_club}
          onChange={onChange}
          placeholder="Téléphone du club"
          icon={FaPhoneAlt}
        />

        <Field
          label="Email"
          name="mail_club"
          value={settings.mail_club}
          onChange={onChange}
          placeholder="contact@club.fr"
          icon={FaEnvelope}
          type="email"
        />

        <Field
          label="Site web"
          name="siteweb_club"
          value={settings.siteweb_club}
          onChange={onChange}
          placeholder="https://..."
          icon={FaGlobe}
        />

        <Field
          label="Facebook"
          name="facebook_club"
          value={settings.facebook_club}
          onChange={onChange}
          placeholder="URL de la page Facebook"
          icon={FaFacebook}
        />

        <Field
          label="Instagram"
          name="instagram_club"
          value={settings.instagram_club}
          onChange={onChange}
          placeholder="URL du compte Instagram"
          icon={FaInstagram}
        />

        <div>
          <label className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200">
            Couleur primaire
          </label>

          <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-700 dark:bg-slate-950">
            <FaPalette className="text-slate-400" />

            <input
              type="color"
              name="primary_color"
              value={settings.primary_color || "#000000"}
              onChange={onChange}
              className="h-10 w-14 cursor-pointer rounded-xl border border-slate-200 bg-white p-1 dark:border-slate-700 dark:bg-slate-900"
            />

            <input
              type="text"
              name="primary_color"
              value={settings.primary_color || "#000000"}
              onChange={onChange}
              className="min-w-0 flex-1 bg-transparent text-sm font-bold text-slate-700 outline-none dark:text-slate-100"
            />
          </div>
        </div>
      </div>
    </section>
  );
}